/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Flex, Text } from "@aws-amplify/ui-react";
export default function SplashText(props) {
  const {
    contactButtonGroup,
    splashBlurbText,
    splashNameText,
    overrides,
    ...rest
  } = props;
  return (
    <Flex
      gap="27px"
      direction="column"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "SplashText")}
      {...rest}
    >
      <Flex
        gap="0"
        direction="column"
        width="unset"
        height="178px"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Top")}
      >
        <Flex
          gap="10px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Career")}
        >
          <Text
            fontFamily="Raleway"
            fontSize="18px"
            fontWeight="500"
            color="rgba(184,184,184,1)"
            lineHeight="21.131999969482422px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Software &#xA;Engineer"
            {...getOverrideProps(overrides, "Software Engineer")}
          ></Text>
        </Flex>
        <Flex
          gap="0"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Greeting")}
        >
          <Text
            fontFamily="Raleway"
            fontSize="80px"
            fontWeight="700"
            color="rgba(45,45,45,1)"
            lineHeight="80px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="-3.85px"
            width="510px"
            height="68px"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Hello I’m"
            {...getOverrideProps(overrides, "Hello I\u2019m")}
          ></Text>
          <Text
            fontFamily="Raleway"
            fontSize="80px"
            fontWeight="700"
            color="rgba(255,0,0,1)"
            lineHeight="80px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="-3.85px"
            width="627px"
            height="68px"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children={splashNameText}
            {...getOverrideProps(overrides, "Remus Courtenay")}
          ></Text>
        </Flex>
      </Flex>
      <Flex
        gap="20px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Bottom")}
      >
        <Text
          fontFamily="Lato"
          fontSize="16px"
          fontWeight="400"
          color="rgba(106,106,106,1)"
          lineHeight="32.2239990234375px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          letterSpacing="0.25px"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children={splashBlurbText}
          {...getOverrideProps(
            overrides,
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque consequat, faucibus et, et. Non semper blandit vitae semper blandit. Tellus dignissim a dui turpis arcu, nulla ullamcorper tincidunt."
          )}
        ></Text>
        <Flex
          padding="0px 0px 0px 0px"
          width="215px"
          height="61.14px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          children={contactButtonGroup}
          {...getOverrideProps(overrides, "ContactButtonGroup")}
        ></Flex>
      </Flex>
    </Flex>
  );
}
